import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

/**
 * Service to manage the sidebar and the app of the page
 */
@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  /**
   * The app variable is declared
   * @param app Variable to save the app
   */
  app = 'undefined';

  /**
   * Apply the app when the service starts
   */
  constructor(private transloco: TranslocoService) {
    this.loadApp();
  }

  /**
   * Function that saves the app at the localStorage
   */
  saveApp() {
    localStorage.setItem('App', JSON.stringify(this.app));
    return true;
  }

  /**
   * Function that brings the app information at localStorage
   */
  loadApp() {
    const storedApp = localStorage.getItem('App');
    if (storedApp !== 'undefined' || storedApp !== null) {
      if (JSON.parse(storedApp ?? 'null')) {
        this.app = JSON.parse(storedApp ?? 'null');
        this.applyApp(this.app);
        return true;
      } else {
        this.app = 'undefined';
        localStorage.setItem('App', JSON.stringify(this.app));
        return false;
      }
    } else {
      this.applyApp(this.app);
    }
  }

  /**
   * Function that use the app on the page
   * @param app Variable that brings the app
   */
  applyApp(app: string) {
    if (app === 'undefined') {
      this.app = app;
      return false;
    } else {
      this.app = app;
      localStorage.setItem('App', JSON.stringify(app));
      this.saveApp();
      return true;
    }
  }

  /**
   * Function that returns the actual app
   */
  getApp() {
    const storedApp = localStorage.getItem('App');
    if (storedApp !== 'undefined' || storedApp !== null) {
      this.app = JSON.parse(storedApp ?? 'null');
      return this.app;
    } else {
      this.app = 'undefined';
      localStorage.setItem('App', JSON.stringify(this.app));
      return this.app;
    }
  }

  getMenu() {
    return [
      {
        submenu: [
          {
            titulo: this.transloco.translate('SIDEBAR.HOME'),
            icono: '../../../assets/images/sidebar/home-red.svg',
            url: '/home',
            outside: false,
          },
          {
            titulo: this.transloco.translate('SIDEBAR.RESOURCES'),
            icono: '../../../assets/images/sidebar/docs-red.svg',
            url: '/general-documents',
            outside: false,
          },
          {
            titulo: this.transloco.translate('SIDEBAR.HELP'),
            icono: '../../../assets/images/sidebar/help-red.svg',
            url: 'https://lab4u.zendesk.com/hc/en-us/requests/new',
            outside: true,
          },
          {
            titulo: this.transloco.translate('SIDEBAR.LOG-OUT'),
            icono: '../../../assets/images/sidebar/logout-red.svg',
            url: '/log-out',
            outside: false,
          },
        ],
      },
    ];
  }

  getSidebarElements() {
    return [
      {
        submenu: [
          {
            titulo: this.transloco.translate('SIDEBAR.GETTING-STARTED'),
            icono: '../../../assets/images/sidebar/getting-started-red.svg',
            url: '/getting-started',
            outside: false,
          },
          {
            titulo: this.transloco.translate('SIDEBAR.TOOLS'),
            icono: '../../../assets/images/sidebar/tools-red.svg',
            url: '/tools',
            outside: false,
          },
          {
            titulo: this.transloco.translate('SIDEBAR.EXPERIMENTS'),
            icono: '../../../assets/images/sidebar/experiments-red.svg',
            url: '/categories',
            outside: false,
          },
          {
            titulo: this.transloco.translate('SIDEBAR.TUTORIALS'),
            icono: '../../../assets/images/sidebar/tutorials-red.svg',
            url: '/tutorials',
            outside: false,
          },
          {
            titulo: this.transloco.translate('SIDEBAR.LOG-OUT'),
            icono: '../../../assets/images/sidebar/logout-red.svg',
            url: '/log-out',
            outside: false,
          },
        ],
      },
    ];
  }
}
